"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var next_components_1 = require("@dotdev/next-components");
var Snippets = require("snippets");
var ProductGroups = /** @class */ (function (_super) {
    __extends(ProductGroups, _super);
    function ProductGroups() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.buildValues = function (products, parent, optionName) {
            var allValues = [];
            products.map(function (product, i) {
                var optionIndex = product.options && product.options.includes(optionName) ? product.options.indexOf(optionName) : null;
                return product.options_with_values
                    .filter(function (option) { return option.name === optionName; })
                    .map(function (option, ii) {
                    option.values.map(function (value, iii) {
                        var valueObj = {
                            name: value,
                            product: product,
                            variant: product.variants.filter(function (variant, iiii) { return variant["option" + (optionIndex + 1)] === value; })[0]
                        };
                        allValues.push(valueObj);
                    });
                });
            });
            allValues.sort(function (a, b) {
                var nameA = a.name.toUpperCase();
                var nameB = b.name.toUpperCase();
                return nameA < nameB ? -1 : nameA > nameB ? 1 : 0;
            });
            return allValues.map(function (value, index) {
                var product = value.product, variant = value.variant;
                // const swatchImages = product.images ? product.images.filter((image) => image.src.match(/_S[_\.]/i)) : null;
                var swatchImages = product.images ? product.images[0] : null;
                return product ? (React.createElement("li", { key: index, className: "mr-1-4 mb-1-4 inline-block align-middle" },
                    React.createElement("a", { href: product.url, title: value.name, "aria-label": product.title + " in " + value.name, className: "block rounded relative overflow-hidden block border transition-fast outline-none focus:outline-none p-0-1 " + (product.id === parent.id ? "border-navy" : "border-transparent hover:border-grey-dark") },
                        React.createElement(Snippets.Image, { ratio: "1:1", bg: "grey-mid", className: "w-6-3 relative rounded overflow-hidden" + (!product.available ? " opacity-50" : ""), src: swatchImages && swatchImages.length
                                ? swatchImages.src
                                : product.images && product.images.length
                                    ? product.images[0].src
                                    : null })))) : null;
            });
        };
        return _this;
    }
    ProductGroups.prototype.render = function () {
        var _a = this.props, optionIndex = _a.optionIndex, products = _a.products, product = _a.product, showTitles = _a.showTitles, title = _a.title, variant = _a.variant;
        var products = products.filter(function (product) { return product.options.includes(title); });
        return products && products.length ? (React.createElement("div", { className: "mb-2" },
            React.createElement("p", { className: "text-xs font-medium mb-0-8" },
                React.createElement("span", { className: "inline-block align-middle text-charcoal mr-0-4" },
                    title,
                    ":"),
                React.createElement("span", { className: "inline-block align-middle text-midnight uppercase font-bold" }, variant && variant["option" + (optionIndex + 1)] ? variant["option" + (optionIndex + 1)] : null)),
            React.createElement("ul", { className: "list-reset whitespace-no-wrap md:whitespace-normal overflow-x-auto md:overflow-visible -mb-1-4" }, this.buildValues(products, product, title)))) : null;
    };
    ProductGroups.contextType = next_components_1.ShopifyNext.Context;
    return ProductGroups;
}(React.PureComponent));
exports.ProductGroups = ProductGroups;
